'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
require('../expression/index.js');
var parseJson = require('../expression/parse-json.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

var PatternOrderBy = /*#__PURE__*/function () {
  function PatternOrderBy(data, schema) {
    _classCallCheck__default["default"](this, PatternOrderBy);
    this.asc = data.asc;
    this.expression = parseJson.parseExprJson(data.expression, schema);
  }
  return _createClass__default["default"](PatternOrderBy, [{
    key: "toJson",
    value: function toJson() {
      return {
        asc: this.asc,
        expression: this.expression.toJson()
      };
    }
  }]);
}();

exports.PatternOrderBy = PatternOrderBy;
